export const normalizeText = (content: ContentText) => {
  return {
    cssId: content.css_id,
    backgroundColor: content.background_color.color,
    categoryH2: content.category_h2,
    categoryH2Color: content.category_h2_color.color,
    categoryH3: content.category_h3,
    categoryH3Color: content.category_h3_color.color,
    headlineH2: content.headline_h2,
    headlineH2Color: content.headline_h2_color.color,
    headlineH3: content.headline_h3,
    headlineH3Color: content.headline_h3_color.color,
    text: content.text,
    textColor: content.text_color.color,
    button: content.button,
  }
}

export const normalizeTextMedia = (content: ContentTextMedia) => {
  return {
    mediumPosition: content.medium_position,
    cssId: content.css_id,
    backgroundColorTextBox: content.background_color_textbox.color,
    backgroundColor: content.background_color?.color,
    category: content.category,
    categoryColor: content.category_color.color,
    headlineH2: content.headline_h2,
    headlineH2Color: content.headline_h2_color.color,
    headlineH3: content.headline_h3,
    headlineH3Color: content.headline_h3_color.color,
    text: content.text,
    textColor: content.text_color.color,
    button: content.button,
    image: content.image ? normalizeImageWrapper(content.image) : undefined,
    video: content.video ? normalizeVideo(content.video) : undefined,
    overlap: content.image_overlap,
  }
}

export const normalizeTariffs = (content: ContentTariff) => {
  return {
    cssId: content.css_id,
    actioncode: content.actioncode,
    headlineH2: content.headline_h2,
    headlineH2Color: content.headline_h2_color.color,
    text: content.text,
    textColor: content.text_color.color,
    hideButtons: content.hide_buttons,
  }
}

export const normalizeMultiteaser = (content: ContentMultiteaser) => {
  return {
    cssId: content.css_id,
    categoryH2: content.category_h2,
    categoryH2Color: content.category_h2_color?.color,
    headlineH2: content.headline_h2,
    headlineH4: content.headline_h4,
    headlineH2Color: content.headline_h2_color.color,
    textAlignment: content.text_alignment,
    text: content.text,
    textColor: content.text_color.color,
    teaser: content.teaser,
  }
}
export const normalizeVideo = (video: Video) => {
  return {
    id: video.video_id,
    title: video.title,
    consentLayer: video.consent_layer,
  }
}

export const normalizeContentVideo = (content: ContentVideo) => {
  return {
    headlineH2: content.headline_h2,
    headlineH2Color: content.headline_h2_color.color,
    text: content.text,
    textColor: content.text_color.color,
    video: content.video ? normalizeVideo(content.video) : undefined,
  }
}

export const normalizeContentAccordion = (content: ContentAccordion) => {
  return {
    categoryH2: content.category_h2,
    categoryH2Color: content.category_h2_color.color,
    headlineH2: content.headline_h2,
    headlineH2Color: content.headline_h2_color.color,
    cssId: content.css_id,
    content: content.content,
  }
}

export const normalizeStage = (content: ContentStage) => {
  return {
    mediumPosition: content.medium_position,
    cssId: content.css_id,
    backgroundColorTextBox: content.background_color_textbox.color,
    backgroundColor: content.background_color?.color,
    headlineH1: content.headline_h1,
    headlineH1Color: content.headline_h1_color.color,
    text: content.text,
    textColor: content.text_color.color,
    button: content.button,
    image: content.image ? normalizeImageWrapper(content.image) : undefined,
    video: content.video ? normalizeVideo(content.video) : undefined,
  }
}

export const normalizeStageFullScreen = (content: ContentStageFullScreen) => {
  return {
    headlineH1: content?.headline_h1,
    headlineH1Color: content?.headline_h1_color?.color,
    video: content.stage_full_screen_video,
    poster: content.poster,
    posterAlt: content.poster_alt,
    posterMobile: content.poster_mobile,
    posterMobileAlt: content.poster_mobile_alt,
    backgroundColor: content.background_color,
    copyright: content.copyright,
    hideAppsBadge: content.hide_apps_badge,
  }
}

export const normalizeImageWrapper = (imageWrapper: ImageWrapper) => {
  return {
    alt: imageWrapper.alt,
    id: imageWrapper.id,
    link: imageWrapper.link,
    image: imageWrapper.image,
    format: imageWrapper.format,
    copyright: imageWrapper.copyright,
  }
}

export const normalizeContentImageSlider = (content: ImageSlider) => {
  return {
    id: content.id,
    headlineH2: content.headline_h2,
    headlineH2Color: content.headline_h2_color.color,
    cssId: content.css_id,
    speedInSeconds: content.speed_in_seconds,
    autoPlay: content.auto_play,
    slides: content.slides.map((slide) => normalizeSlide(slide)),
  }
}

export const normalizeSlide = (slide: Slide) => {
  return {
    ...slide,
    video: slide.video ? normalizeVideo(slide.video) : undefined,
  }
}

export const normalizeContentLocations = (content: ContentLocations) => {
  return {
    categoryH2: content.category,
    categoryH2Color: content.category_color.color,
    headlineH2: content.headline_h2,
    headlineH2Color: content.headline_h2_color.color,
    cssId: content.css_id,
    text: content.text,
    textColor: content.text_color.color,
    button: content.button,
    backgroundColor: content.background_color?.color,
    backgroundColorTextBox: content.background_color_textbox.color,
    locations: content.locations,
  }
}

export const normalizeContentContactForm = (content: ContentContactForm) => {
  return {
    cssId: content.css_id,
    headlineH2: content.headline_h2,
    headlineH2Color: content.headline_h2_color.color,
    text: content.text,
    textColor: content.text_color.color,
    form: content.form,
  }
}

export const normalizeButtonBanner = (content: ButtonBanner) => {
  return {
    buttons: content.buttons,
    backgroundColor: content.background_color.color,
  }
}

export const normalizeBenefitsMedia = (content: ContentBenefitsMedia) => {
  return {
    categoryH2: content?.category_h2,
    categoryH2Color: content.category_h2_color.color,
    headlineH2: content.headline_h2,
    headlineH2Color: content.headline_h2_color.color,
    listStyle: content.list_style,
    imagePositionDesktop: content.image_position_desktop,
    imagePositionMobile: content.image_position_mobile,
    text: content.text,
    image: content.image ? normalizeImageWrapper(content.image) : undefined,
    cssId: content?.css_id,
    benefits: content.benefit_list,
    button: content.button,
  }
}
